import { useParams } from "react-router";
import { ReviewPage } from "./review/ReviewPage";
import { StagePage } from "../layout/StagePage";
import { stageHeadingLabel } from "../stage-vocabulary";
import { StageSources } from "@/v2/layout/StageSources";

/** Generate Patent Draft's first page, the review before you generate. Zero props by contract. */
export function GenerateReviewPane() {
  const { taskId } = useParams<{ taskId: string }>();
  return (
    <StagePage
      guide="generate"
      testId="generate-review-pane"
      taskId={taskId}
      eyebrow={stageHeadingLabel("generate")}
      title="Review before you generate"
      lede={
        <>
          This is everything you have settled across the workflow. Use the{" "}
          <strong>Edit</strong> links to change anything before you generate.
          The draft uses this content as it is when you generate.
        </>
      }
    >
      <StageSources taskId={taskId} stage="generate" />
      {taskId !== undefined && <ReviewPage taskId={taskId} />}
    </StagePage>
  );
}
